//
//
//   { 
//      lineWidth : 1,              //Border Size
//      strokeStyle : "#00000000",  //HEX RGBA
//      fillStyle : "#00000000",    //HEX RGBA (polygon only)
//
//      symbol : {
//          image : canvas,
//          offsetX : -offset,
//          offsetY : -offset
//      }
//   }
//
//
function loadStyle(text) {
  var parsedElements = parse(text);

  return createStyle(parsedElements);
}

function previewStyleData(text) {
  var iconWidth = 25;
  var iconHeight = 25;

  var parsedElements = parse(text);

  for (var elem of parsedElements) {
    if (elem.type === "polyline") {
      elem.type = "custom";
      elem.path = parsePath("M0 10 L 4 2 L 6 8 L 10 0");
      elem.w = iconWidth * 0.6;
      elem.h = iconHeight * 0.6;
      elem.ox = elem.bs / 2;
      elem.oy = elem.bs / 2;
      elem.fa = 0;
    }
    else if (elem.type === "polygon") {
      elem.type = "rectangle";
      elem.w = iconWidth * 0.7;
      elem.h = iconHeight * 0.7;
      elem.ox = elem.bs / 2;
      elem.oy = elem.bs / 2;
    }
  }

  var style = createStyle(parsedElements);
  var sourceCanvas = style.symbol.image;

  var clippedData = clipPaintedData(sourceCanvas);

  return clippedData;
}

function clipPaintedData(canvas) {
  var context = canvas.getContext('2d');

  var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
  var data = imageData.data;

  var minX = canvas.width;
  var minY = canvas.height;
  var maxX = 0;
  var maxY = 0;

  var w = canvas.width;

  var count = data.length;
  for (var i = 0; i < count; i += 4) {
    //alpha 0
    if (data[i + 3] === 0)
      continue;

    var px = i / 4 % w;
    var py = (i / 4 - px) / w;

    if (minX > px)
      minX = px;
    if (maxX < px)
      maxX = px;
    if (minY > py)
      minY = py;
    if (maxY < py)
      maxY = py;
  }

  if (minX > maxX)
    return null;

  return context.getImageData(minX, minY, (maxX - minX) + 1, (maxY - minY) + 1);
}


function createStyle(elements) {
  var style = {};
  var margin = 8;

  var symbolWidth = 0;
  var symbolHeight = 0;

  var validSymbolTypes = ["rectangle", "ellipse", "lozenge", "triangle", "5PointStar", "custom", "text"];

  var elem;

  // check elements size to define canvas size
  for (elem of elements) {
    if (validSymbolTypes.indexOf(elem.type) < 0)
      continue;

    symbolWidth = Math.max(symbolWidth, elem.w + (Math.abs(elem.ox) + margin) * 2);
    symbolHeight = Math.max(symbolHeight, elem.h + (Math.abs(elem.oy) + margin) * 2);
  }

  var context = createSymbolContext(style, symbolWidth, symbolHeight);
  var textElements = [];

  for (elem of elements) {
    switch (elem.type) {
      case "rectangle":
        drawRectangle(context, elem.w, elem.h, elem.cr, elem.bs, elem.bc, elem.ba, elem.fc, elem.fa, elem.ox + margin, elem.oy + margin);
        break;
      case "ellipse":
        drawEllipse(context, elem.w, elem.h, elem.bs, elem.bc, elem.ba, elem.fc, elem.fa, elem.ox + margin, elem.oy + margin);
        break;
      case "lozenge":
        drawLozenge(context, elem.w, elem.h, elem.bs, elem.bc, elem.ba, elem.fc, elem.fa, elem.ox + margin, elem.oy + margin);
        break;
      case "triangle":
        drawTriangle(context, elem.w, elem.h, elem.bs, elem.bc, elem.ba, elem.fc, elem.fa, elem.ox + margin, elem.oy + margin);
        break;
      case "5PointStar":
        draw5PointStar(context, elem.w, elem.h, elem.bs, elem.bc, elem.ba, elem.fc, elem.fa, elem.ox + margin, elem.oy + margin);
        break;
      case "custom":
        drawSymbolFromPathElements(context, elem.path, elem.w, elem.h, elem.bs, elem.bc, elem.ba, elem.fc, elem.fa, elem.ox + margin, elem.oy + margin);
        break;
      case "text":
        textElements.push(elem);
        break;

      case "polyline":
        style.lineWidth = elem.bs;
        style.strokeStyle = convertToRGBA(elem.bc, elem.ba);
        break;
      case "polygon":
        style.lineWidth = elem.bs;
        style.strokeStyle = convertToRGBA(elem.bc, elem.ba);
        style.fillStyle = convertToRGBA(elem.fc, elem.fa);
        break;
      default:
        break;
    }
  }

  //if (textElements.length)
  //console.log("elements", textElements);

  var fixX = 0;
  var fixY = elements.length !== textElements.length ? 4 : 0;

  for (elem of textElements) {
    drawText(context, elem.w, elem.h, elem.ts, elem.tf, elem.tc, elem.italic, elem.bold, elem.underline, elem.txt, elem.ox + margin + fixX, elem.oy + margin + fixY);
  }

  return style;
}

// function convertToHexRGBA(color, alpha) {
//   return "#" + ('000000' + ((color) >>> 0).toString(16)).slice(-6) + ('00' + Math.round(255 * alpha).toString(16)).slice(-2);
// }

function convertToRGBA(color, alpha) {
  var c = '0x' + ('000000' + ((color) >>> 0).toString(16)).slice(-6);

  return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + alpha + ')';
}

function parse(text) {
  var results = [];

  var ini = 0;
  var end = 0;

  if (text == null)
    text = "";

  text = text.replace(/[\r?\n?]/g, "");
  text = text.replace(/\t/g, " ");
  text = text.replace(/,/g, ".");

  while (true) {
    ini = text.indexOf('{', end);
    if (ini === -1)
      break;

    end = text.indexOf('}', ini);
    if (end < ini)
      break;

    var attributes = text.slice(ini + 1, end).split(';');

    var elem = { type: "rectangle", ox: 0, oy: 0, w: 10, h: 10, path: parsePath("M0 0 L0 10 L10 10 L10 0 L5 5 L0 0"), cr: 0, bs: 1, bc: 0x000000, ba: 1, fc: 0x0000FF, fa: 1, txt: "A", tc: 0x007700, tf: "Arial", ts: 12, bold: false, italic: false, underline: false, hs: 0, hc: 0xFFFFFF };

    for (var str of attributes) {
      var strArray = str.split(":");
      var name = strArray[0].toString().replace(/ /g, "").toLowerCase();
      var value;

      var intValue;
      var numberValue;
      var stringValue;


      switch (name) {
        case "type":
          if ((strArray[1] === "rectangle") ||
            (strArray[1] === "ellipse") ||
            (strArray[1] === "lozenge") ||
            (strArray[1] === "triangle") ||
            (strArray[1] === "5PointStar") ||
            (strArray[1] === "custom") ||
            (strArray[1] === "polyline") ||
            (strArray[1] === "polygon") ||
            (strArray[1] === "text"))
            value = strArray[1];
          else
            continue;
          //throw new Error("SYMBOLFACTORY: Unknown element type \""+ strArray[1] +"\"");

          break;
        case "ox":
          //offset x
          intValue = parseInt(strArray[1], 10);
          if (isNaN(intValue))
            continue;

          value = intValue;
          break;
        case "oy":
          //offset y
          intValue = parseInt(strArray[1], 10);
          if (isNaN(intValue))
            continue;

          value = intValue;
          break;
        case "w":
          //width
          intValue = parseInt(strArray[1], 10);
          if (isNaN(intValue) || intValue <= 0)
            continue;

          value = intValue;
          break;
        case "h":
          //height
          intValue = parseInt(strArray[1], 10);
          if (isNaN(intValue) || intValue <= 0)
            continue;

          value = intValue;
          break;
        case "path":
          value = parsePath(strArray[1]);
          if (value == null)
            continue;
          break;
        case "cr":
          //corner radius
          intValue = parseInt(strArray[1], 10);
          if (isNaN(intValue) || intValue < 0)
            continue;

          value = intValue;
          break;
        case "bs":
          //border size
          intValue = parseInt(strArray[1], 10);
          if (isNaN(intValue) || intValue <= 0)
            continue;

          value = intValue;
          break;
        case "bc":
          //border color
          intValue = parseInt(strArray[1], 16);
          if (isNaN(intValue) || intValue < 0)
            continue;

          value = intValue;
          break;
        case "ba":
          //border alpha
          numberValue = parseFloat(strArray[1]);
          if (isNaN(numberValue) || numberValue < 0 || numberValue > 1)
            continue;

          value = numberValue;
          break;
        case "fc":
          //fill color
          intValue = parseInt(strArray[1], 16);
          if (isNaN(intValue) || intValue < 0)
            continue;

          value = intValue;
          break;
        case "fa":
          //fill alpha
          numberValue = parseFloat(strArray[1]);

          if (isNaN(numberValue) || numberValue < 0 || numberValue > 1)
            continue;

          value = numberValue;
          break;
        case "txt":
          //text value
          if (strArray.length === 1)
            continue;

          stringValue = strArray[1].replace(/ /g, "").replace(/[\r?\n?]/g, "");
          if (stringValue.length === 0)
            continue;

          value = stringValue;
          break;
        case "tc":
          //text color
          intValue = parseInt(strArray[1], 16);
          if (isNaN(intValue) || intValue < 0)
            continue;

          value = intValue;
          break;
        case "tf":
          //text font
          stringValue = strArray[1];
          if (stringValue == null || stringValue.length === 0)
            continue;

          value = stringValue;
          break;
        case "ts":
          //text size
          numberValue = parseFloat(strArray[1]);
          if (isNaN(numberValue) || numberValue <= 0)
            continue;

          value = numberValue;
          break;
        case "bold":
          value = true;
          break;
        case "italic":
          value = true;
          break;
        case "underline":
          value = true;
          break;
        case "hs":
          //halo size
          intValue = parseInt(strArray[1], 10);
          if (isNaN(intValue) || intValue < 0 || intValue > 4)
            continue;

          value = intValue;
          break;
        case "hc":
          //halo color
          intValue = parseInt(strArray[1], 16);
          if (isNaN(intValue) || intValue < 0)
            continue;

          value = intValue;
          break;
        default:
          continue;
      }

      elem[name] = value;
    }

    results.push(elem);
  }

  return results;
}

function parsePath(path) {
  var results = [];

  if (path == null)
    return results;

  path = path.toUpperCase();

  var subPathArray = path.split("M");

  for (var subPath of subPathArray) {

    if (subPath === "")
      continue;

    var pointStringArray = subPath.split("L");
    var points = [];

    for (var pointString of pointStringArray) {
      var coordArray = pointString.split(" ");
      var pos = coordArray.length - 1;

      while (pos >= 0) {
        var num = parseFloat(coordArray[pos]);
        if (isNaN(num))
          coordArray.splice(pos, 1);
        else
          coordArray[pos] = num;
        pos--;
      }

      if (coordArray.length !== 2) {
        points = null;
        break;
      }

      points.push(coordArray);
    }

    if (points)
      results.push(points);
  }

  return results;
}

function createSymbolContext(style, width, height) {
  if (width === 0 || height === 0)
    return null;

  var canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  style.symbol = { image: canvas, offsetX: -canvas.width / 2, offsetY: -canvas.height / 2 };

  var context = canvas.getContext('2d');

  context.imageSmoothingEnabled = true;
  context.mozImageSmoothingEnabled = true;
  context.webkitImageSmoothingEnabled = true;
  context.msImageSmoothingEnabled = true;

  //context.lineCap="round";
  //context.lineJoin="bevel";
  //context.lineJoin="round";
  context.miterLimit = 2;

  return context;
}



function drawRectangle(context, width, height, cornerRadius, borderSize, borderColor, borderAlpha, fillColor, fillAlpha, offsetX, offsetY) {

  context.lineWidth = borderSize;
  context.strokeStyle = convertToRGBA(borderColor, borderAlpha);
  context.fillStyle = convertToRGBA(fillColor, fillAlpha);

  if (cornerRadius) {
    var dx = Math.min(width / 2, cornerRadius);
    var dy = Math.min(height / 2, cornerRadius);

    var mx = dy !== dx ? 1 : 0;
    var my = mx;

    context.beginPath();
    context.moveTo(offsetX + dx, offsetY);
    context.lineTo(offsetX + width - dx, offsetY);
    context.quadraticCurveTo(offsetX + width - mx, offsetY + my, offsetX + width, offsetY + dy);
    context.lineTo(offsetX + width, offsetY + height - dy);
    context.quadraticCurveTo(offsetX + width - mx, offsetY + height - my, offsetX + width - dx, offsetY + height);
    context.lineTo(offsetX + dx, offsetY + height);
    context.quadraticCurveTo(offsetX + mx, offsetY + height - my, offsetX, offsetY + height - dy);
    context.lineTo(offsetX, offsetY + dy);
    context.quadraticCurveTo(offsetX + mx, offsetY + my, offsetX + dx, offsetY);
    context.closePath();

    context.fill();
    context.stroke();
  }
  else {
    context.fillRect(offsetX, offsetY, width, height);
    context.strokeRect(offsetX, offsetY, width, height);
  }
}

function drawEllipse(context, width, height, borderSize, borderColor, borderAlpha, fillColor, fillAlpha, offsetX, offsetY) {

  context.lineWidth = borderSize;
  context.strokeStyle = convertToRGBA(borderColor, borderAlpha);
  context.fillStyle = convertToRGBA(fillColor, fillAlpha);

  //radius
  var rx = width / 2;
  var ry = height / 2;

  //center
  var cx = offsetX + rx;
  var cy = offsetY + ry;

  context.beginPath();
  context.ellipse(cx, cy, rx, ry, 0, 0, 2 * Math.PI);
  context.closePath();

  context.fill();
  context.stroke();
}

function drawLozenge(context, width, height, borderSize, borderColor, borderAlpha, fillColor, fillAlpha, offsetX, offsetY) {

  context.lineWidth = borderSize;
  context.strokeStyle = convertToRGBA(borderColor, borderAlpha);
  context.fillStyle = convertToRGBA(fillColor, fillAlpha);

  //center
  var cx = offsetX + width / 2;
  var cy = offsetY + height / 2;

  context.beginPath();
  context.moveTo(offsetX, cy);
  context.lineTo(cx, offsetY + height);
  context.lineTo(offsetX + width, cy);
  context.lineTo(cx, offsetY);
  context.lineTo(offsetX, cy);
  context.closePath();

  context.fill();
  context.stroke();
}

function drawTriangle(context, width, height, borderSize, borderColor, borderAlpha, fillColor, fillAlpha, offsetX, offsetY) {

  context.lineWidth = borderSize;
  context.strokeStyle = convertToRGBA(borderColor, borderAlpha);
  context.fillStyle = convertToRGBA(fillColor, fillAlpha);

  //center
  var cx = offsetX + width / 2;

  context.beginPath();
  context.moveTo(offsetX, offsetY + height);
  context.lineTo(offsetX + width, offsetY + height);
  context.lineTo(cx, offsetY);
  context.closePath();

  context.fill();
  context.stroke();
}

function draw5PointStar(context, width, height, borderSize, borderColor, borderAlpha, fillColor, fillAlpha, offsetX, offsetY) {
  var starPoints = [[0, 54], [64, 54], [84, 0], [104, 54], [166, 54], [114, 89], [134, 144], [84, 110], [34, 144], [52, 89], [0, 54]];

  drawSymbolFromPathElements(context, [starPoints], width, height, borderSize, borderColor, borderAlpha, fillColor, fillAlpha, offsetX, offsetY);
}

function drawSymbolFromPathElements(context, pathElements, width, height, borderSize, borderColor, borderAlpha, fillColor, fillAlpha, offsetX, offsetY) {

  context.lineWidth = borderSize;
  context.strokeStyle = convertToRGBA(borderColor, borderAlpha);
  context.fillStyle = convertToRGBA(fillColor, fillAlpha);


  context.beginPath();

  var scaledElements = scaleElements(pathElements, width, height);

  for (var scaledPoints of scaledElements) {
    var count = scaledPoints.length;

    if (scaledPoints.length > 1) {
      context.moveTo(scaledPoints[0][0] + offsetX, scaledPoints[0][1] + offsetY);

      for (var i = 1; i < count; i++) {
        context.lineTo(scaledPoints[i][0] + offsetX, scaledPoints[i][1] + offsetY);
      }
    }
  }

  //context.closePath();

  context.fill('evenodd');
  context.stroke();
}

function drawText(context, width, height, fontSize, fontName, textColor, italic, bold, underline, text, offsetX, offsetY) {

  var fontSettings = "";

  if (italic)
    fontSettings += " italic";

  if (bold)
    fontSettings += " bold";

  fontSettings += " " + fontSize + "px " + fontName;


  context.fillStyle = convertToRGBA(textColor, 1);
  context.font = fontSettings;
  context.textBaseline = "middle";
  context.textAlign = "center";

  //center
  var cx = offsetX + width / 2;
  var cy = offsetY + height / 2;

  context.fillText(text, cx, cy);



  if (underline) {
    var underlineX = offsetX + 6;
    var underlineY = -1;
    var textWidth = context.measureText(text).width;

    switch (context.textAlign) {
      case "center":
        underlineX -= Math.round(textWidth / 2);
        break;
      case "right":
        underlineX -= Math.round(textWidth);
        break;
      default:
        break;
    }

    underlineY += fontSize + offsetY;

    context.lineWidth = 1;
    context.strokeStyle = context.fillStyle;

    context.beginPath();
    context.moveTo(underlineX, underlineY);
    context.lineTo(underlineX + Math.round(textWidth), underlineY);
    context.stroke();
  }

  /*
      context.fillStyle = "#FF0000";
      context.beginPath();
      context.arc(cx, cy, 2, 0, 2 * Math.PI, false);
      context.closePath();
      context.fill();
  */
}




function scaleElements(elements, width, height) {
  var scaledElements = [];

  if (elements == null || elements.length === 0)
    return scaledElements;

  var xMin = Number.POSITIVE_INFINITY;
  var yMin = Number.POSITIVE_INFINITY;
  var xMax = Number.NEGATIVE_INFINITY;
  var yMax = Number.NEGATIVE_INFINITY;

  var scaledPoints;
  var point;

  for (var elementPoints of elements) {
    scaledPoints = [];

    for (point of elementPoints) {
      if (point[0] < xMin)
        xMin = point[0];

      if (point[0] > xMax)
        xMax = point[0];

      if (point[1] < yMin)
        yMin = point[1];

      if (point[1] > yMax)
        yMax = point[1];

      scaledPoints.push([point[0], point[1]]);
    }

    if (scaledPoints.length)
      scaledElements.push(scaledPoints);
  }

  if (scaledElements.length === 0)
    return scaledElements;

  var deltaX = xMax - xMin;
  var deltaY = yMax - yMin;
  var measure = (deltaX > deltaY) ? deltaX : deltaY;

  var scaleX = width / measure;
  var scaleY = height / measure;

  for (scaledPoints of scaledElements) {
    for (point of scaledPoints) {
      point[0] *= scaleX;
      point[1] *= scaleY;
    }
  }

  return scaledElements;
}





var StyleFactory = {
  loadStyle: loadStyle,
  previewStyleData: previewStyleData
};

export default StyleFactory;
